import { render, staticRenderFns } from "./write.vue?vue&type=template&id=07a155c5"
import script from "./write.vue?vue&type=script&lang=ts"
export * from "./write.vue?vue&type=script&lang=ts"
import style0 from "./write.vue?vue&type=style&index=0&id=07a155c5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,LoadingSpinner: require('/vercel/path0/components/loading-spinner.vue').default,ChefDetailCard: require('/vercel/path0/components/chef/detail-card.vue').default,UiInput: require('/vercel/path0/components/ui/input.vue').default,UiButton: require('/vercel/path0/components/ui/button.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
